var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconClass)?_c('div',{staticClass:"svg-icon iconfont",class:_vm.iconClass}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }